'use client';

import {
  cx,
  TabsNavigation,
  TabsNavigationLink,
} from '@otter-ai/den-components';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import { RolloutGroupLink } from '@/shared/components/RolloutGroupLink';
import { useAccountSettingsNavItems } from './useAccountSettingsNavItems';

export { usePrefetchAccountSettingsNavItems } from './useAccountSettingsNavItems';

/**
 * The navigation shown on settings pages.
 *
 * To update the items and order, update the `useAccountSettingsNavItems`
 * hook in `./account-settings-config.tsx`.
 */
export function AccountSettingsNav() {
  const pathname = usePathname();
  const { items: navItems, isReady } = useAccountSettingsNavItems();
  // Active path state - pathname has a delay when route changes
  const [activePath, setActivePath] = useState(pathname);
  // need to sync when user clicks back button in the browser
  useEffect(() => {
    setActivePath(pathname);
  }, [pathname]);

  return (
    <TabsNavigation
      size="md"
      data-testid="account-settings-nav"
      className={cx(
        'transition-opacity duration-300 md:justify-center',
        !isReady && 'opacity-0 pointer-events-none',
      )}
    >
      {navItems.map((item) => (
        <TabsNavigationLink
          key={item.href}
          data-testid={item.dataTestId}
          active={item.isActive?.(activePath) ?? activePath === item.href}
          href={item.href}
          LinkComponent={RolloutGroupLink}
          onClick={() => setActivePath(item.href)}
        >
          {item.text}
        </TabsNavigationLink>
      ))}
    </TabsNavigation>
  );
}
